import { Card, CardContent } from '@shared/components';
import { formatVerbatimMoneyCurrency } from '@shared/utils/formatMoneyDisplay';
import type { TotalsEntry } from '../../utils/statementRows';

interface Props {
    totals: TotalsEntry[];
    currency: string;
}

const headingId = 'agreement-financials-plan-balance';

export function PlanBalanceCard({ totals, currency }: Props) {
    const balance = totals.find((entry) => entry.key === 'balance');
    const movements = totals.filter((entry) => entry.key !== 'balance');

    return (
        <Card>
            <CardContent className="py-5">
                <section aria-labelledby={headingId} className="@container space-y-3">
                    <h3 id={headingId} className="text-base font-semibold text-mp-foreground">
                        Plan Balance
                    </h3>
                    <div className="grid gap-4 @md:grid-cols-3 @md:gap-0">
                        <dl className="grid gap-4 text-mp-foreground @md:col-span-2 @md:grid-cols-2">
                            {movements.map((entry) => (
                                <Figure key={entry.key} entry={entry} currency={currency} />
                            ))}
                        </dl>
                        {balance && (
                            <dl className="border-mp-border text-mp-success @md:border-l @md:pl-3">
                                <Figure entry={balance} currency={currency} />
                            </dl>
                        )}
                    </div>
                </section>
            </CardContent>
        </Card>
    );
}

function Figure({ entry, currency }: { entry: TotalsEntry; currency: string }) {
    return (
        <div className="space-y-1">
            <dt className="text-sm text-mp-muted">{entry.label}</dt>
            <dd className="text-xl font-semibold">{formatVerbatimMoneyCurrency(entry.value, currency)}</dd>
        </div>
    );
}
